import React from 'react';

//component
import ReportTypeForm from '../../../components/siteadmin/ReportTypeManagement/ReportTypeForm/ReportTypeForm';

const AddReportType = () => {
    let initialValues;

    initialValues = {
        dynamicReportType: [{
            language: 'en'
        }],
    }
    return (
        <ReportTypeForm initialValues={initialValues} />
    )
}

export default AddReportType;